(function () {
  'use strict';

  angular.module('sempraWebapp')
    .directive('totalMoneyByDaysChart', totalMoneyByDaysChartDirective)
    .controller('totalMoneyByDaysChartController', totalMoneyByDaysChartController);

  /** @ngInject */
  function totalMoneyByDaysChartDirective($timeout) {
    return {
      restrict: 'E',
      scope: {
        data: '='
      },
      templateUrl: 'app/components/totalMoneyByDaysChart/totalMoneyByDaysChart.html',
      controller: 'totalMoneyByDaysChartController',
      controllerAs: 'vm',
      link: function (scope) {
        $timeout(function () {
          scope.vm.refresh(scope.data);
          scope.$watch('data', function (newValue) {
            scope.vm.refresh(newValue);
          });
        }, 100)
      }
    };
  }

  /** @ngInject */
  function totalMoneyByDaysChartController($scope) {
    var vm = this;

    vm.chart = null;
    vm.chartElementId = 'totalMoneyByDaysChart';
    vm.refresh = refreshChart;

    init();

    function init() {
      $scope.$on('$destroy', destroy);
    }

    function destroy() {
      if (vm.chart) {
        vm.chart.destroy();
      }
    }

    function refreshChart(data) {
        var groupColumnName = 'date',
        rowsData = [];

      if (data === null) {
        return;
      }

      rowsData = [[groupColumnName].concat(data.facilities)];

      data.dates.forEach(function (item) {
        rowsData.push([item.date].concat(item.values));
      });

      vm.chart === null
        ? createChart(vm.chartElementId, groupColumnName, rowsData)
        : updateChart(groupColumnName, rowsData);

    }

    function createChart(chartElementId, groupColumnName, rowsData) {
      vm.chart = c3.generate({
        bindto: '#' + chartElementId,
        data: {
          x: groupColumnName,
          rows: rowsData
        },
        subchart: {
          show: true
        },
        axis: {
          x: {
            type: 'timeseries',
            tick: {
              format: '%Y-%m-%d'
            }
          }
        }
      });
    }

    function updateChart(groupColumnName, rowsData) {
      vm.chart.load({
        data: {
          x: groupColumnName,
          rows: rowsData
        },
        subchart: {
          show: true
        },
        axis: {
          x: {
            type: 'timeseries',
            tick: {
              format: '%Y-%m-%d'
            }
          }
        }
      });
    }
  }
})();
